export const PLAYBOOK_CATEGORY_LABELS = {
  dealer_onboarding: "Dealer Onboarding",
  inventory_quality: "Inventory Quality",
  lead_followup: "Lead Follow-up",
  trust_safety: "Trust & Safety",
  buyer_launch: "Buyer Launch",
  seo: "SEO Publishing",
  analytics: "Analytics Review",
  dealer_trials: "Dealer Trials",
  templates: "Message Templates",
  admin_reference: "Admin Reference",
};

export const PLAYBOOK_AUDIENCE_LABELS = {
  founder: "Founder",
  admin: "Admin",
  dealer_success: "Dealer success",
  inventory_operator: "Inventory operator",
  trust_safety: "Trust & safety",
  marketing: "Marketing",
  support: "Support",
};

export const PLAYBOOK_STATUS_LABELS = {
  draft: "Borrador",
  active: "Activo",
  needs_review: "Revisar",
  archived: "Archivado",
};

export const CHECKLIST_RECURRENCE_LABELS = {
  daily: "Diario",
  weekly: "Semanal",
  launch: "Launch",
  per_dealer: "Por dealer",
  per_case: "Por caso",
  per_import: "Por importación",
  one_time: "Una vez",
};

export function trackOperationsPlaybookEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[operations-playbook-event]", eventType, metadata);
  }
}

export function statusBadgeClass(status) {
  if (status === "active") return "badge badge--success";
  if (status === "needs_review") return "badge badge--warning";
  if (status === "archived") return "badge badge--muted";
  return "badge";
}
